import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FilterService } from "../../../../filter/services/filter.service";

@Component({
    selector: 'gen-applied-filter',
    templateUrl: './applied-filter.component.html',
    styleUrls: ['./applied-filter.component.scss']
})

export class AppliedFilterComponent {
    @Input() filter: any;
    @Output() newFilterEvent = new EventEmitter<string>();


  constructor(
        private filterService: FilterService
      ) {}

    public clearFilter(filter: any) {
      this.newFilterEvent.emit(filter);
      this.filterService.clearAppliedFilters(filter);
    }
}
